import { render, staticRenderFns } from "./FlightPassengersInformation.vue?vue&type=template&id=019239fd&scoped=true&"
import script from "./FlightPassengersInformation.vue?vue&type=script&lang=js&"
export * from "./FlightPassengersInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019239fd",
  null
  
)

/* custom blocks */
import block0 from "./FlightPassengersInformation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
